<template>
	<svg
		width="21px"
		height="16px"
		viewBox="0 0 21 16"
		version="1.1"
		xmlns="http://www.w3.org/2000/svg"
		xmlns:xlink="http://www.w3.org/1999/xlink"
		alt="desktop icon"
	>
		<g
			id="Meetings"
			stroke="none"
			stroke-width="1"
			fill="none"
			fill-rule="evenodd"
		>
			<g
				transform="translate(-180.000000, -23.000000)"
				:fill="color"
				fill-rule="nonzero"
			>
				<g transform="translate(171.000000, 15.000000)">
					<path
						d="M27.484375,21.0999994 C28.7734375,21.0999994 29.4375,20.4749994 29.4375,19.1546869 L29.4375,10.7249994 C29.4375,9.40468693 28.7734375,8.77187443 27.484375,8.77187443 L11.8359375,8.77187443 C10.5390625,8.77187443 9.8828125,9.40468693 9.8828125,10.7249994 L9.8828125,19.1546869 C9.8828125,20.4749994 10.5390625,21.0999994 11.8359375,21.0999994 L27.484375,21.0999994 Z M24.328125,23.8499994 C24.71875,23.8499994 25.03125,23.5374994 25.03125,23.1468744 C25.03125,22.7562494 24.71875,22.4437494 24.328125,22.4437494 L14.96875,22.4437494 C14.5859375,22.4437494 14.2734375,22.7562494 14.2734375,23.1468744 C14.2734375,23.5374994 14.5859375,23.8499994 14.96875,23.8499994 L24.328125,23.8499994 Z"
					></path>
				</g>
			</g>
		</g>
	</svg>
</template>

<script>
export default {
	name: 'Desktop',
	props: {
		color: {
			type: String,
			default: '#bcbcbc',
		},
	},
}
</script>
